'use strict';

import React from 'react'

import Image from '@Pure/Image'

export default class DataRow extends React.Component
{
	render ()
	{
		const component = this, props = this.props;

		var elements  = [], component_class, i = 0, output;

		component_class = component.props.parity % 2 === 0 ? '' : ' c-data-row--odd';

		Object.keys(props.data).forEach(function (key, index)
		{
			if (typeof props.displayed_fields[key] === undefined) return;

			var li_class = 'o-grid__item c-data-row__item';

			if (props['model-config']?.header_map?.[key])
			{
				li_class += ' ' + props['model-config'].model + '-' +
					props['model-config'].header_map[key];
			}

			if (['number', 'string', 'undefined'].indexOf(typeof props.data[key]) !== -1)
			{
				elements.push
				(
					<li className={ li_class } key={ i++ }>
						{ props.data[key] }
					</li>
				);
			}
			else if (props.data[key].hasOwnProperty('ReactElement'))
			{
				if (typeof props.data[key].item_className === 'string')
				{
					li_class += ' ' + props.data[key].item_className;
				}

				elements.push
				(
					<li className={ li_class } key={ i++ }>
						{ props.data[key].ReactElement }
					</li>
				);
			}
		});

		if (props.small === true)
		{
			component_class += ' c-data-row--small';
		}

		if (props.selected === true)
		{
			component_class += ' c-data-row--selected';
		}

		if (props.onClick || props.clickable === true)
		{
			component_class += ' c-data-row--clickable';
		}

		if (props.version)
		{
			component_class += ' c-data-row--v' + String(props.version);
		}

		if (props.onClick)
		{
			output =
			(
				<ul onClick={ function (e) { props.onClick(props); } }
					className={ 'c-data-row' + component_class }>
					{ elements }
				</ul>
			);
		}
		else
		{
			output =
			(
				<ul className={ 'c-data-row' + component_class }>
					{ elements }
				</ul>
			);
		}

		return output;
	}
}